<template>
  <div class="verne-vue3 cat-loading-component">
    <div class="bar-container">
      <div class="fill-bar"></div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatLoadingComponent"
});
</script>
